module.exports = __webpack_public_path__ + "static/img/safeDun.ae2cee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/safeDun.png
// module id = OQ6o
// module chunks = 2